import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDocumentInfo } from 'interfaces';
import fetchDocumentToViewer from 'store/reducers/viewerCreator';

type ViewerStateType = {
  isOpenViewer: boolean;
  documentUrl: any;
  documentName: string;
  documentExtention: string;
  documentToView: IDocumentInfo | null;
  isDocumentLoading: boolean;
  isDocumentError: string;
  viewerAbortController: AbortController | null;
};

const initialState: ViewerStateType = {
  isOpenViewer: false,
  documentUrl: '',
  documentName: '',
  documentExtention: '',
  documentToView: null,
  isDocumentLoading: false,
  isDocumentError: '',
  viewerAbortController: null,
};

const viewerSlice = createSlice({
  name: 'webviewer',
  initialState,
  reducers: {
    setIsOpenViewer: (state, action: PayloadAction<boolean>) => {
      state.isOpenViewer = action.payload;
      if (action.payload === false) state.documentToView = null;
    },

    setIsDocumentError: (state, action: PayloadAction<string>) => {
      state.isDocumentError = action.payload;
      state.isDocumentLoading = false;
    },

    resetViewerSlice: (state) => {
      state.isDocumentLoading = false;
      state.isDocumentError = '';
      state.documentExtention = '';
      state.documentUrl = '';
      state.documentName = '';
    },
    setViewerSlice: (state, action: PayloadAction<{fileURL: any, extension: string, filename: string}>) => {
      state.isDocumentLoading = false;
      state.isDocumentError = '';
      state.documentExtention = action.payload.extension;
      state.documentUrl = action.payload.fileURL;
      state.documentName = action.payload.filename;
      state.documentToView = null;
    },
    setDocumentToViewNull: (state) => {
      state.documentToView = null;
    },

    setViewerLoading: (state) => {
      state.isDocumentLoading = true;
    },

    setViewerAbortController(
      state,
      action: PayloadAction<AbortController | null>
    ) {
      if (action.payload) {
        state.viewerAbortController = action.payload;
      } else {
        state.viewerAbortController = null;
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchDocumentToViewer.pending, (state) => {
      state.isDocumentLoading = true;
      state.isDocumentError = '';
      state.documentUrl = '';
    });

    builder.addCase(fetchDocumentToViewer.rejected, (state, action: any) => {
      state.isDocumentLoading = false;
      state.isDocumentError = action.payload;
      state.documentUrl = '';
    });

    builder.addCase(fetchDocumentToViewer.fulfilled, (state, action: PayloadAction<{fileURL: any, extension: string, filename: string, document?: IDocumentInfo}>) => { 
      if (action.payload.fileURL) {
        state.isDocumentLoading = false;
        state.isDocumentError = '';
        state.documentExtention = action.payload.extension;
        state.documentUrl = action.payload.fileURL;
        state.documentName = action.payload.filename;
        state.viewerAbortController = null;
      } else {
        state.documentToView = action.payload.document || null;
      }
    });
  },
});

const viewerReducer = viewerSlice.reducer;

export const {
  setIsOpenViewer,
  setIsDocumentError,
  resetViewerSlice,
  setViewerSlice,
  setDocumentToViewNull,
  setViewerLoading,
  setViewerAbortController,
} = viewerSlice.actions;
export default viewerReducer;
